/**
 * @desc 根据入参条件查询相关库容信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.MaterialStorageRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.MaterialStorageDTO>>> {
  return defHttp.post({
    url: '/web/materialManage/query',
    data,
  });
}

export function mock(
  data: defs.MaterialStorageRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.MaterialStorageDTO>>> {
  return defHttp.post({
    url: '/mock/web/materialManage/query',
    data,
  });
}
